import BookingDetails from "../../commonComponents/BookingDetails";

const BookingInfo = () => <BookingDetails />

export default BookingInfo;
